<template>
  <div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit">实名认证</div>
		</div>
    <div class="img">
       <img src="../images/user/shibai.png" class="auth-upload-img" />
    </div>
    <div class="tip_txt">
      <span class="reason">{{ data.reject_reason }}</span>
    </div>
    <div class="auth-btn-bar">
      <button class="auth-btn" @click="submit">去认证</button>
    </div>
  </div>
</template>

<script>

import Fetch from '../../utils/fetch'

export default {
  name: 'UserAuth',
  data() {
    return {
      data:{}
    };
  },
 
  mounted() {
    this.start();
  },
  methods: {
    start() {
        Fetch('/user/authInfo').then((r) => {
            this.data = r.data;
        });
    },
    submit() {
      this.$router.push('/auth');
    }
  }
};
</script>

<style scoped>
.auth-manage-bg {
  min-height: 100vh;
  background: #f6f7fb;
}
.auth-header {
  display: flex;
  align-items: center;
  height: 43px;
  background: linear-gradient(to right, #ff5252, #ff8044);;
  box-shadow: 0 2px 8px rgba(255,107,47,0.08);
  position: relative;
}
.auth-header-back {
  width: 44px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.auth-header-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-right: 44px;
}
.auth-manage-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f8f8;
}
.img {
  width: 100%;
  display: flex;
  justify-content: center;
}
.auth-upload-img {
  margin-top: 20px;
  width: 80%;
}
.tip_txt {
  width: 100%;
  margin-top: 20px;
  font-size: 16px;
  color: #ff4d4f;
  text-align: center;
}
.reason {
  font-weight: bold;
  width: 80vh;
}
.auth-btn-bar {
  margin: 32px 24px 0 24px;
}
.auth-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg,#ff6a2f 0%,#ff3b3b 100%);
  color: #fff;
  border: none;
  border-radius: 1cap;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  box-shadow: 0 2px 8px rgba(255,107,47,0.08);
  transition: background 0.2s;
}
.auth-btn:disabled {
  background: #e0e0e0;
  color: #b0b3c6;
  cursor: not-allowed;
}
</style>